"use client";

import type { ComponentProps, ReactNode } from "react";
import posthog from "posthog-js";
import { LEAD_FORM_ANCHOR, type LeadFormLocation } from "./content";
import { useLeadFormDialog } from "./lead-form-dialog";

export type LeadFormLinkLocation = LeadFormLocation;

type LeadFormLinkProps = Omit<ComponentProps<"a">, "href"> & {
  children: ReactNode;
  location: LeadFormLocation;
};

export function LeadFormLink({
  children,
  location,
  onClick,
  ...props
}: LeadFormLinkProps) {
  const { open } = useLeadFormDialog();

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    posthog.capture("business_landing_cta_clicked", { location });
    open(location);
    onClick?.(event);
  }

  return (
    <a href={LEAD_FORM_ANCHOR} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
